module.exports = __webpack_public_path__ + "img/menuCopyWhite.54464622.svg";